/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerformatigstory3Inputs */

const en_flyerformatigstory3 = /** @type {(inputs: Flyerformatigstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IG Story`)
};

const de_flyerformatigstory3 = /** @type {(inputs: Flyerformatigstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IG Story`)
};

/**
* | output |
* | --- |
* | "IG Story" |
*
* @param {Flyerformatigstory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerformatigstory3 = /** @type {((inputs?: Flyerformatigstory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerformatigstory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerformatigstory3(inputs)
	return de_flyerformatigstory3(inputs)
});
export { flyerformatigstory3 as "flyerFormatIgStory" }